import { Icon } from "@iconify/react";
import { useCallback, useContext } from "react";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../../../Containers/PopupModalContainer";
import { MARKIT_QUIET_HOURS } from "@markit/common.utils";
import { Colors } from "../../../../utils/colors";
import RectangleButton from "../../../Buttons/RectangleButton";
import { useDispatch, useSelector } from "react-redux";
import TextHoverButton from "../../../Buttons/TextHoverButton";
import {
  changeBypassQuietHours,
  getAccountState,
} from "../../../../redux/slices/accountSlice";
import { showNotificationBanner } from "../../../../utils/notificationUtils";
import { NotificationType } from "@markit/common.types";
import { MixpanelContext } from "../../../../context/AnalyticsService";

type QuietHoursDisableModalProps = {
  setIsVisible: (isVisible: boolean) => void;
};

const QuietHoursDisableModal = (props: QuietHoursDisableModalProps) => {
  const { setIsVisible } = props;
  const dispatch = useDispatch();
  const mixpanel = useContext(MixpanelContext);
  const { uid } = useSelector(getAccountState).account.accountData;

  const confirmDisableQuietHours = useCallback(() => {
    dispatch(changeBypassQuietHours(uid, true, mixpanel));
    showNotificationBanner(
      dispatch,
      "Quiet Hours Disabled",
      NotificationType.AFFIRMATIVE
    );
    setIsVisible(false);
  }, [dispatch, setIsVisible, uid, mixpanel]);

  return (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 14 }}>
          <Icon icon="ion:moon" height={35} />
          <div className="ColumnNormal" style={{ gap: 10 }}>
            <span className="sectionTitle">Disable Quiet Hours?</span>
            <span className="bodySubtext">
              As per SMS guidelines, marketing messages are not allowed to be
              sent between 7:30pm - 8am to comply with SMS regulations.
            </span>
            <span className="bodySubtext">
              If your texts do not qualify as marketing messages, disabling
              quiet hours will allow you to send texts at any time of day.
              However, you must acknowledge that you assume full responsibility
              for any violations in compliance.
            </span>
            <TextHoverButton
              text="Learn More"
              onPress={() => window.open(MARKIT_QUIET_HOURS)}
              icon={
                <Icon
                  icon="ion:chevron-forward"
                  height={14}
                  style={{ color: Colors.BLACK, marginBottom: -1 }}
                />
              }
              iconPosition="right"
              textStyles={{ color: Colors.BLACK, fontWeight: 500 }}
            />
          </div>
        </div>
      }
      valueComp={
        <div className="AlignedRow" style={{ gap: 10 }}>
          <RectangleButton
            buttonLabel="Cancel"
            onPress={() => setIsVisible(false)}
            altTextColor={Colors.BLACK}
            altColor={Colors.WHITE1}
            containerStyles={{ border: `0.5px solid ${Colors.GRAY2}` }}
            altPaddingVert={14}
          />
          <RectangleButton
            buttonLabel="I acknowledge"
            onPress={confirmDisableQuietHours}
            altTextColor={Colors.WHITE}
            altColor={Colors.BLACK}
            altPaddingVert={14}
          />
        </div>
      }
      noExit
      closeOnOutsidePress
      modalContentWidth={PopupModalContainerWidth.SMALL}
      closeModal={() => setIsVisible(false)}
    />
  );
};

export default QuietHoursDisableModal;
